import useTranslate from "@/hooks/useTranslate";
import classNames from "classnames";
import { useCptUtil_02 } from "./useCptUtil_02";
import { homeAtom } from "@/atoms/home";
import { useClsUtil_02 } from "./useClsUtil_02";
const Sunrise: React.FC<any> = ({ forecast1day = undefined, current = undefined }) => {
  const homeData = useAtomValue(homeAtom);
  const { getCls01, getCls02 } = useClsUtil_02();
  forecast1day = (forecast1day || homeData?.data?.["forecast1day"]) ?? {};
  current = (current || homeData?.data?.["current"]) ?? {};
  const { $t } = useTranslate();
  const { getCpt02 } = useCptUtil_02({ getCls02, forecast1day, current, $t });

  const SunriseContent2 = () => {
    return <WeatherContent className={classNames(getCls01())}>{getCpt02()}</WeatherContent>;
  };
  return <SunriseContent2 />;
};
export default Sunrise;
